import script from "./TerminationService.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminationService.vue?vue&type=script&setup=true&lang=js"

import "./TerminationService.vue?vue&type=style&index=0&id=13096400&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13096400"]])

export default __exports__